import { authenticatedAjax, REQUEST } from "../../../../config/ajax-wrapper";
import { AnyAction } from "redux";
import { errorAutorizacion } from "src/co/sura/inicio/modulos/inicioActions";
import {
    CONSULTAR_NOVEDADES_DETALLE,
    CONSULTAR_NOVEDADES_DETALLE_XLS,
    EXITO_CONSULTA_NOVEDADES_DETALLE,
    EXITO_CONSULTA_NOVEDADES_DETALLE_XLS,
    ERROR_CONSULTA_NOVEDADES_DETALLE,
    ERROR_CONSULTA_NOVEDADES_DETALLE_XLS,
    LIMPIAR_MENSAJES_ESTADO,
    ENVIAR_CAMBIO_ESTADO,
    EXITO_ENVIAR_CAMBIO_ESTADO,
    ERROR_ENVIAR_CAMBIO_ESTADO,
    exitoConsultaNovedadesDetalle,
    errorConsultaNovedadesDetalle,
    exitoConsultaNovedadesDetalleXLS,
    errorEnviarCambioEstado,
    exitoEnviarCambioEstado
} from "./reciboNovedadesDetalleActions";
import { FiltroConsultaReciboDetalle } from "../../config_general_recibo/modelo/NovedadesRecibidas";
import fileDownload from "js-file-download";
import * as moment from "moment";
import { DetalleNovedad } from "../modelo/ConsultaNovedadesDetalle";
import {
    cabeceraReporteDetalleReciboSAT,
    LibroDocumentoXLS
} from "../../../general/modelo/PlanillasXLS";
import { crearPlantillaXLS } from "../../../general/componentes/GenerarPlantillaXLS";

export const consultarNovedadesDetalleEpic = action$ =>
    action$.ofType(CONSULTAR_NOVEDADES_DETALLE)
        .mergeMap((action: any) => {

            const url = `sat/consultar-novedades-recibidas/detalle?${obtenerParametrosFiltro(action.filtro)}`;

            return authenticatedAjax
                .get(url)
                .map(response => {
                    const respuesta = JSON.parse(response.response);
                    return exitoConsultaNovedadesDetalle(respuesta.datosEntidad, respuesta.paginas, respuesta.totalDatos);
                }).catch(response => {
                    if (response.status === 401 || response.status === 403) {
                        return [errorAutorizacion(response.response, response.status)];
                    }
                    return [errorConsultaNovedadesDetalle()];
                });
        });

export const consultarNovedadesDetalleXLSEpic = action$ =>
    action$.ofType(CONSULTAR_NOVEDADES_DETALLE_XLS)
        .mergeMap((action: any) => {

            const url = `sat/consultar-novedades-recibidas/detalle?${obtenerParametrosFiltro(action.filtro)}`;

            return authenticatedAjax
                .get(url)
                .map(response => {
                    const respuesta = JSON.parse(response.response);
                    const excelBlob: Blob = construirXLS(respuesta.datosEntidad, respuesta.nombresColumnas);
                    const nombreArchivo = `reporte_${moment(moment.now()).format("DD_MM_YYYY_HHmmss")}.xlsx`;
                    fileDownload(
                        excelBlob,
                        nombreArchivo,
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    );
                    return exitoConsultaNovedadesDetalleXLS();
                }).catch(response => {
                    if (response.status === 401 || response.status === 403) {
                        return [errorAutorizacion(response.response, response.status)];
                    }
                    return [errorConsultaNovedadesDetalle()];
                });
        });

export const enviarCambioEstadoEpic = action$ =>
    action$.ofType(ENVIAR_CAMBIO_ESTADO)
        .mergeMap((action: any) => {

            const url = 'sat/administrar/novedades_recibidas';

            return authenticatedAjax
                .post(
                    url,
                    action.datosEnvio,
                    { 'Content-Type': 'application/json', 'proceso': 'CAMBIAR_ESTADO_NOVEDAD_RECIBIDA' }
                )
                .map(response => exitoEnviarCambioEstado()
                ).catch(response => {
                    if (response.status === 401 || response.status === 403) {
                        return [errorAutorizacion(response.response, response.status)];
                    }
                    return [errorEnviarCambioEstado()];
                });
        });

export const reciboNovedadesDetalleReducer = (state =
    {
        tamanoPagina: undefined,
        paginaActual: undefined,
        paginas: undefined,
        totalRegistros: undefined,
        estadoConsultaDetalle: REQUEST.NONE,
        estadoDescargaXLS: REQUEST.NONE,
        estadoEnvioCambioEstado: REQUEST.NONE,
        detalleNovedades: []
    }, action: AnyAction) => {

    switch (action.type) {
        case CONSULTAR_NOVEDADES_DETALLE:
            return {
                ...state,
                estadoConsultaDetalle: REQUEST.PENDING,
                detalleNovedades: [],
                paginas: 0,
                totalRegistros: 0,
                tamanoPagina: action.filtro.tamanoPagina,
                paginaActual: action.filtro.paginaActual
            };
        case CONSULTAR_NOVEDADES_DETALLE_XLS:
            return {
                ...state,
                estadoDescargaXLS: REQUEST.PENDING,
            };
        case EXITO_CONSULTA_NOVEDADES_DETALLE:
            return {
                ...state,
                estadoConsultaDetalle: REQUEST.SUCCESS,
                detalleNovedades: action.datosEntidad,
                paginas: action.paginas,
                totalRegistros: action.totalDatos
            };
        case EXITO_CONSULTA_NOVEDADES_DETALLE_XLS:
            return {
                ...state,
                estadoDescargaXLS: REQUEST.SUCCESS
            };
        case ERROR_CONSULTA_NOVEDADES_DETALLE:
            return {
                ...state,
                estadoConsultaDetalle: REQUEST.ERROR,
                detalleNovedades: [],
                paginas: 0,
                totalRegistros: 0
            };
        case ERROR_CONSULTA_NOVEDADES_DETALLE_XLS:
            return {
                ...state,
                estadoDescargaXLS: REQUEST.ERROR
            };
        case ENVIAR_CAMBIO_ESTADO:
            return {
                ...state,
                estadoEnvioCambioEstado: REQUEST.PENDING
            };
        case EXITO_ENVIAR_CAMBIO_ESTADO:
            return {
                ...state,
                estadoEnvioCambioEstado: REQUEST.SUCCESS
            };
        case ERROR_ENVIAR_CAMBIO_ESTADO:
            return {
                ...state,
                estadoEnvioCambioEstado: REQUEST.ERROR
            };
        case LIMPIAR_MENSAJES_ESTADO:
            return {
                ...state,
                estadoConsultaDetalle: REQUEST.NONE,
                estadoDescargaXLS: REQUEST.NONE,
                estadoEnvioCambioEstado: REQUEST.NONE,
                tamanoPagina: undefined,
                paginaActual: undefined,
                paginas: undefined,
                totalRegistros: undefined
            };
        default:
            return state;
    }
};

const obtenerParametrosFiltro = (filtro: FiltroConsultaReciboDetalle) => {
    let params = new URLSearchParams();
    if (filtro) {

        if (filtro.dniEmpleador) params.set('dniEmpleador', filtro.dniEmpleador);
        if (filtro.fechaInicial) params.set('fechaInicio', filtro.fechaInicial);
        if (filtro.fechaFinal) params.set('fechaFin', filtro.fechaFinal);
        if (filtro.servicio) params.set('servicio', filtro.servicio.toString());
        if (filtro.codigoConsulta) params.set('codigoConsulta', filtro.codigoConsulta.toString());
        if (filtro.consecutivoSolicitud) params.set('consecutivoSolicitud', filtro.consecutivoSolicitud);
        if (filtro.estados) {
            filtro.estados.forEach(estado => params.append('estado', estado.toString()));
        }

        if (filtro.paginaActual) params.set('pagina', (filtro.paginaActual + 1).toString());
        else params.set('pagina', '1');
        if (filtro.tamanoPagina) params.set('registrosPorPagina', filtro.tamanoPagina.toString());
        else params.set('registrosPorPagina', '10');
    }

    return params.toString();
};

const construirXLS = (datos: Array<DetalleNovedad>, columnas: Array<string>) => {
    if (!datos || !datos.length)
        return;
    /*Libros a generar en el XLS*/
    const libro = 'Reporte Detalle Novedades Recibidas SAT';
    const librosXLS = [libro];

    const datosEmpresas = [];

    const validarVacio = (dato: any) => {
        return dato ? dato : '';
    };

    const obtenerOtrosDetalles = (jsonString: string) => {
        const json = JSON.parse(jsonString);
        return columnas.map(columna => ({ value: validarVacio(json[columna]) }));
    };

    datos.forEach(registro => {
        datosEmpresas.push([
            { value: validarVacio(registro.consecutivo) },
            { value: validarVacio(registro.consecutivoResumen) },
            { value: validarVacio(registro.consecutivoRespuestaSAT) },
            { value: validarVacio(registro.dniEmpleador) },
            { value: validarVacio(registro.usuarioTransaccionSAT) },
            { value: validarVacio(registro.nombreUsuarioTransaccionSAT) },
            { value: validarVacio(registro.fechaIngresoSAT) },
            { value: validarVacio(registro.estado) },
            { value: validarVacio(registro.observacion) },
            { value: validarVacio(registro.error) },
            { value: validarVacio(registro.dniProcesaSURA) },
            { value: validarVacio(registro.fechaProcesaSURA) },
            { value: validarVacio(registro.esReprocesado) },
            { value: validarVacio(registro.reproceso) },
            { value: validarVacio(registro.dniReprocesaSURA) },
            { value: validarVacio(registro.fechaReprocesaSURA) },
            { value: validarVacio(registro.fechaIngresaSistema) }
        ].concat(obtenerOtrosDetalles(registro.otrosCampos)));
    });

    /*Datos para generar el XLS*/
    const datosLibrosXLS: LibroDocumentoXLS[] = [{
        nombreLibro: libro,
        cabecera: cabeceraReporteDetalleReciboSAT(columnas),
        datos: datosEmpresas,
    }];

    return crearPlantillaXLS(librosXLS, datosLibrosXLS);
};


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/recibo_novedades_detalle/modulos/reciboNovedadesDetalleReducers.ts